module.exports = __webpack_public_path__ + "img/filter-2.29881930.svg";